var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "layout-list" }, [
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.saveLobbyTV },
              },
              [_vm._v("儲存")]
            ),
          ],
          1
        ),
      ]),
      _c("el-form", [
        _vm.LobbyData
          ? _c(
              "div",
              [
                _c("span", [_vm._v("設定")]),
                _c(
                  "draggable",
                  {
                    staticClass: "frame-list",
                    attrs: {
                      list: _vm.LobbyData.Frames,
                      "ghost-class": "ghost",
                      group: { name: "myGroup", pull: "clone", put: false },
                      itemKey: "id",
                      options: { animation: 500 },
                      sort: false,
                    },
                  },
                  _vm._l(_vm.LobbyData.Frames, function (Frame, index) {
                    return _c(
                      "div",
                      { key: Frame.Guid, staticClass: "frame-wrap" },
                      [
                        _c("span", { staticClass: "frame-name" }, [
                          _vm._v(_vm._s(Frame.Name)),
                        ]),
                        Frame.Type !== 1
                          ? _c(
                              "div",
                              { staticClass: "video-wrap" },
                              [
                                _c("el-switch", {
                                  staticStyle: { display: "inline-block" },
                                  attrs: {
                                    "active-color": "#66b1ff",
                                    "inactive-color": "#66b1ff",
                                    "active-text": "上傳圖片",
                                    "inactive-text": "上傳影片",
                                    "active-value": 4,
                                    "inactive-value": 3,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.clearFrameValue(index)
                                    },
                                  },
                                  model: {
                                    value: Frame.Type,
                                    callback: function ($$v) {
                                      _vm.$set(Frame, "Type", $$v)
                                    },
                                    expression: "Frame.Type",
                                  },
                                }),
                                _c("br"),
                                _c("br"),
                                _c(
                                  "el-form-item",
                                  [
                                    Frame.Type === 4 && Frame.ImgInfo
                                      ? _c("img", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            src: Frame.ImgInfo.HeadPhotoBase64,
                                            alt: "",
                                          },
                                        })
                                      : _vm._e(),
                                    Frame.Type === 3 && Frame.FileInfo
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(Frame.FileInfo.FileName)
                                          ),
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "el-upload",
                                      {
                                        ref: `Frame${index}`,
                                        refInFor: true,
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          accept:
                                            Frame.Type === 4
                                              ? "image/*"
                                              : "video/mp4",
                                          limit: 1,
                                          "on-change": (file, fileList) => {
                                            _vm.uploadFile(
                                              file,
                                              fileList,
                                              index
                                            )
                                          },
                                          "auto-upload": false,
                                          "show-file-list": false,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "primary",
                                            },
                                          },
                                          [_vm._v("上傳")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            )
          : _vm._e(),
        _c("div", [_c("span", [_vm._v("排版")])]),
        _vm.LobbyData && _vm.LobbyData.Formats
          ? _c(
              "div",
              { staticClass: "format-block", staticStyle: { display: "flex" } },
              _vm._l(_vm.LobbyData.Formats, function (format) {
                return _c(
                  "div",
                  {
                    key: format.FormatId,
                    staticStyle: { "margin-right": "30px" },
                  },
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: format.FormatId },
                        on: { input: _vm.changeFormat },
                        model: {
                          value: _vm.currentFormat,
                          callback: function ($$v) {
                            _vm.currentFormat = $$v
                          },
                          expression: "currentFormat",
                        },
                      },
                      [_vm._v(_vm._s(format.FormatName))]
                    ),
                    _c(
                      "div",
                      { staticClass: "format-list" },
                      _vm._l(format.Sorts, function (dragWrap) {
                        return _c(
                          "draggable",
                          {
                            key: dragWrap.Seq,
                            staticClass: "drag-wrap",
                            attrs: {
                              list: dragWrap.Frames,
                              group: {
                                name: "my-group",
                                pull: true,
                                put: true,
                              },
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onChange(
                                  $event,
                                  format.FormatId,
                                  dragWrap.Seq
                                )
                              },
                            },
                          },
                          _vm._l(dragWrap.Frames, function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "frame-wrap" },
                              [
                                _vm._v(" " + _vm._s(item.Name) + " "),
                                _c("eva-icon", {
                                  staticClass: "remove-btn",
                                  attrs: {
                                    name: "close-circle",
                                    fill: "#FFF",
                                    width: "30",
                                    height: "30",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFrame(
                                        item.Guid,
                                        format.FormatId,
                                        dragWrap.Seq
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }